import { useState, useEffect, useCallback } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';

import { Tab, Tabs } from '@mui/material';
import { toggleAdminView } from 'store/actions/uiActions';
import { ampli } from 'ampli';
import theme from 'assets/customisedMUI/theme';

const tabOptions = [
    { title: 'Dashboard', link: '/teacher', isAdminView: false },
    { title: 'Lessons', link: '/teacher/classes/dashboard/curriculum', isAdminView: false, requiresClass: true },
    { title: 'Reporting', link: '/teacher/classes/dashboard/reporting', isAdminView: false, requiresClass: true },
    { title: 'Students', link: '/teacher/classes/dashboard/students', isAdminView: false, requiresClass: true },
    {
        title: 'Getting Started',
        link: '/teacher/classes/dashboard/getting-started',
        isAdminView: false,
        requiresClass: false,
    },
    { title: 'Executive Report', link: '/school/admin/exec-report', isAdminView: true },
    { title: 'Classes', link: '/school/admin/classes', isAdminView: true },
    { title: 'Teachers', link: '/school/admin/teachers', isAdminView: true },
    { title: 'Students', link: '/school/admin/students', isAdminView: true },
    { title: 'School Units', link: '/school/admin/units', isAdminView: true },
];

const NavTabs = (props) => {
    const { location, hidden, isAdminView, history, toggleAdminView, scrollable } = props;
    const [currentTab, setCurrentTab] = useState(0);
    const currentTabOptions = tabOptions.filter((option) => option.isAdminView === isAdminView);

    const handlePageChange = useCallback(
        (e, newTab) => {
            ampli.buttonClicked({ button_name: currentTabOptions[newTab].title, location: 'Top Navigation Bar' });
            history.push(currentTabOptions[newTab].link);
        },
        [currentTabOptions, history]
    );

    useEffect(() => {
        const newTab = tabOptions.find((option) =>
            option.link === '/teacher' ? location.pathname === option.link : location.pathname.includes(option.link)
        );
        const newTabIndex = tabOptions.indexOf(newTab);
        if (newTabIndex >= 0) {
            toggleAdminView(tabOptions[newTabIndex].isAdminView);
            const newTabOptions = tabOptions.filter(
                (option) => option.isAdminView === tabOptions[newTabIndex].isAdminView
            );
            setCurrentTab(newTabOptions.indexOf(newTab));
        }
    }, [location, toggleAdminView]);

    return hidden ? null : (
        <Tabs
            scrollButtons={scrollable}
            allowScrollButtonsMobile
            value={currentTab}
            onChange={handlePageChange}
            style={{ flex: '1 1 411px' }}
            variant='scrollable'
        >
            {currentTabOptions.map((tab, index) => {
                const selected = index === currentTab;
                return (
                    <Tab
                        key={index}
                        style={{ color: selected ? '#ffffff' : 'white', opacity: selected ? 1 : 0.7 }}
                        label={tab.title}
                        disabled={tab.requiresClass && !props.hasClass}
                        sx={{
                            textTransform: 'none',
                            minWidth: 72,
                            fontWeight: theme.typography.fontWeightRegular,
                            marginRight: theme.spacing(3),
                            fontFamily: 'Museo700',
                            opacity: 0.7,
                            '&:hover': {
                                color: 'white',
                                opacity: 1,
                            },
                            '&:focus': {
                                color: 'white',
                            },
                            '& > span': {
                                fontFamily: 'Museo700',
                            },
                        }}
                    ></Tab>
                );
            })}
        </Tabs>
    );
};

const mapDispatchToProps = (dispatch) => {
    return {
        toggleAdminView: (adminView) => dispatch(toggleAdminView(adminView)),
    };
};

export default withRouter(
    connect(() => {
        return {};
    }, mapDispatchToProps)(NavTabs)
);
